import React, { useState } from 'react';
import { useTheme } from '../../context/shared/ThemeContext'
import SuggestionsModal from '../SuggestionsModal';

interface ChatInputProps {
  onSendMessage: (text: string) => void;
  isSending: boolean;
  onSendToAll?: (text: string) => void;
  // The props below are not currently used but may be in the future
  // isPatient: boolean;
  // hasTherapist: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({
  onSendMessage,
  isSending,
  onSendToAll,
  // isPatient,
  // hasTherapist,
}) => {
  const [input, setInput] = useState('');
  const [isSuggestionsModalOpen, setIsSuggestionsModalOpen] = useState(false);
  const { themeClasses } = useTheme();

  const handleSendToAllClick = () => {
    if (!input.trim() || isSending) return;
    if (onSendToAll) {
      onSendToAll(input.trim());
    }
    setInput('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim() || isSending) return;
    onSendMessage(input.trim());
    setInput('');
  };
  
  const handleSelectSuggestion = (suggestion: string) => {
    setInput(suggestion);
    setIsSuggestionsModalOpen(false);
  };

  return (
    <div className="border-t border-gray-200 bg-white pt-2 pb-4 px-4">
      {/* Top row for secondary actions */}
      <div className="flex justify-center items-center gap-4 mb-3">
        <button
          onClick={() => setIsSuggestionsModalOpen(true)}
          className={`px-3 py-1.5 text-sm rounded-lg flex items-center gap-2 ${themeClasses.buttonSecondary}`}
        >
          <span>✨</span>
          <span>Need inspiration?</span>
        </button>
      </div>

      {/* Main input form */}
      <form onSubmit={handleSubmit} className="flex items-end gap-2">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
          placeholder="Type your message..."
          className={`flex-grow p-3 border rounded-lg resize-none ${themeClasses.input} ${themeClasses.border} ${themeClasses.primaryText}`}
          rows={2}
          disabled={isSending}
        />
        <div className="flex flex-col gap-2">
          <button
            type="submit"
            disabled={!input.trim() || isSending}
            className={`px-4 py-2 rounded-lg text-white font-semibold ${isSending ? 'bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-700'} disabled:opacity-50`}
          >
            Send
          </button>
          <button
            type="button"
            onClick={handleSendToAllClick}
            disabled={!input.trim() || isSending}
            className={`px-4 py-2 text-sm rounded-lg ${themeClasses.buttonSecondary} disabled:opacity-50`}
          >
            Send to All
          </button>
        </div>
      </form>
      
      <SuggestionsModal
        isOpen={isSuggestionsModalOpen}
        onClose={() => setIsSuggestionsModalOpen(false)}
        onSelectSuggestion={handleSelectSuggestion}
        suggestions={[
            "How are you feeling today?",
            "What's been on your mind lately?",
            "Tell me about a recent challenge you faced.",
        ]}
      />
    </div>
  );
};

export default ChatInput; 